import { render, staticRenderFns } from "./index.vue?vue&type=template&id=508bc372&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconDocument: require('/usr/src/app/components/icons/icon-document.vue').default,TwoItemsCta: require('/usr/src/app/components/common-sections/two-items-cta.vue').default})
